import {createStyles} from '@mantine/core';
import {ProOptions} from 'reactflow';

import BenchlingConfig from 'BenchlingConfig';

// Add this as the "proOptions" prop on ReactFlow instances
export const REACT_FLOW_PRO_OPTIONS: ProOptions = {
  account: 'paid-pro',
  hideAttribution: true,
};

export function getZoomAnimationDurationMs(): number {
  return BenchlingConfig.REACTFLOW_ZOOM_ANIMATION_DURATION_MS;
}

export function getFitViewAnimationDurationMs(): number {
  return BenchlingConfig.REACTFLOW_FIT_VIEW_ANIMATION_DURATION_MS;
}

const useReactFlowStyles = createStyles(() => ({
  preventScrollIntoView: {
    // by default, reactflow adds "overflow: hidden" to the reactflow wrapper div
    // But cypress tests will use javascript to scroll the element into view
    // this means cypress can scroll the canvas offscreen in a way that a user can't
    // adding overflow: clip prevents this from happening
    overflow: 'clip !important',
  },
}));

/**
 * Hook that returns default ReactFlow props with proper className applied.
 * This className prevents Cypress tests from scrolling the canvas offscreen.
 *
 * IMPORTANT: ReactFlow does not respect overflow when passed as inline style,
 * so we must use a className with !important to override ReactFlow's own styles.
 */
export function useDefaultReactFlowProps(): {
  proOptions: ProOptions;
  className: string;
} {
  const {classes} = useReactFlowStyles();
  return {
    proOptions: REACT_FLOW_PRO_OPTIONS,
    className: classes.preventScrollIntoView,
  };
}
